import { render } from "./SectionComponent.vue?vue&type=template&id=c3d57a74"
import script from "./SectionComponent.vue?vue&type=script&lang=js"
export * from "./SectionComponent.vue?vue&type=script&lang=js"

import exportComponent from "/home/nucleares/openmct/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__